module.exports = __webpack_public_path__ + "img/erin-patterson3.b1283744.png";